import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5 18.5H19V20.5H5V18.5Z", fill: "#89A6FF" }), /* @__PURE__ */ React.createElement("path", { d: "M8.41 10.09L7 11.5L12 16.5L17 11.5L15.59 10.09L13 12.67V3.5H11V12.67L8.41 10.09Z", fill: "#89A6FF" }));
const ForwardRef = forwardRef(SvgDownloadIcon);
export { ForwardRef as ReactComponent };
